import { useEffect, useState } from "react";
import { api } from "../../lib/api";
import { DashboardStats } from "./DashboardStats";
import { QuickActions } from "./QuickActions";
import { UpcomingSessionsTable } from "./UpcomingSessionsTable";
import { ActionRequiredPanel } from "./ActionRequiredPanel";
import { RecentActivityFeed } from "./RecentActivityFeed";

export const AdminDashboardHome = () => {
  const [data, setData] = useState(null);

  useEffect(() => {
    api.get("/admin/dashboard").then(({ data }) => setData(data));
  }, []);

  if (!data) {
    return <p className="font-medium text-midnight-black/60" data-testid="dashboard-loading">Loading dashboard...</p>;
  }

  return (
    <div className="space-y-12" data-testid="admin-dashboard-home">
      <DashboardStats stats={data.stats} />

      <div>
        <h2 className="font-extrabold uppercase text-sm tracking-wide mb-4">Quick Actions</h2>
        <QuickActions />
      </div>

      <div>
        <h2 className="font-extrabold uppercase text-sm tracking-wide mb-4">Upcoming Sessions</h2>
        <UpcomingSessionsTable sessions={data.upcoming_sessions} />
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
        <div>
          <h2 className="font-extrabold uppercase text-sm tracking-wide mb-4">Action Required</h2>
          <ActionRequiredPanel items={data.action_required} />
        </div>
        <div>
          <h2 className="font-extrabold uppercase text-sm tracking-wide mb-4">Recent Activity</h2>
          <RecentActivityFeed logs={data.recent_activity} />
        </div>
      </div>
    </div>
  );
};
